import { useMutation } from '@tanstack/react-query';

const usePostcodeSuggestions = () =>
  useMutation({
    mutationFn: async (postcode: string) => {
      const res = await fetch(
        `https://api.postcodes.io/postcodes/${postcode.replace(/\s/g, '')}/autocomplete`
      );
      if (!res.ok) throw new Error(`Failed with status ${res.status}`);
      const data = await res.json();
      return data.result || [];
    },
  });

export default usePostcodeSuggestions;
